import { useBroadcastChannel } from '@vueuse/core'
import { watch } from 'vue'

/**
 * 同步多 Tab 间 store 状态
 * TODO：目前对 persist 不为 true 的 store 应该不支持，后续需要支持
 * @returns
 */
export function createSyncPlugin () {
  return ({ store }) => {
    const { data, post } = useBroadcastChannel({ name: `pinia-sync-${store.$id}` })

    // 监听来自其他窗口的消息并更新 store
    watch(data, (newValue) => {
      if (newValue) {
        const parsedData = JSON.parse(newValue)
        store.$patch(parsedData)
      }
    })

    // 监听本窗口内的 store 变化并广播消息
    store.$subscribe((_mutation, state) => {
      const deserializeData = JSON.stringify(state)
      post(deserializeData)
    })
  }
}
